import 'slick-carousel'
import './slider'
import './common'
import './header'
import './labo-sidenav'
import './scroll'
import './ie'
